import { RESET_STATE, SET_AUTOPARKS, SET_IS_AUTOPARKS_LOADING, SET_PAGINATION, SET_TABLE_SEARCH } from './actions';

export const initialState = {
	autoparks: null,
	isAutoparksLoading: false,
	pagination: null,
	tableSearch: '',
};

const carsContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_AUTOPARKS:
			return {
				...state,
				autoparks: payload,
			};
		case SET_IS_AUTOPARKS_LOADING:
			return {
				...state,
				isAutoparksLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case SET_TABLE_SEARCH:
			return {
				...state,
				tableSearch: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default carsContainerReducer;
